var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A Use Case library for working with Circuit Relays.

  TODO: Build these methods:
  - pruneConnections() - Disconnect dead or misbehaving nodes.
  - addRelay() - Add a new relay to the state.
*/
var bootstrapCircuitRelays = require('../../config/bootstrap-circuit-relays'); // const RelayEntity = require('../entities/relay-entity')


var RelayUseCases = /*#__PURE__*/function () {
  "use strict";

  function RelayUseCases() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RelayUseCases);

    // Dependency Injection.
    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Must inject instance of adapters when instantiating Relay Use Cases library.');
    }

    this.controllers = localConfig.controllers;

    if (!this.controllers) {
      throw new Error('Must inject instance of controllers when instantiating Relay Use Cases library.');
    }
  } // Connect to the pre-programmed circuit relays for the first time at startup.


  _createClass(RelayUseCases, [{
    key: "initializeRelays",
    value: function () {
      var _initializeRelays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thisNode) {
        var bootstrapRelays, i, thisRelay, connectionStatus, now, newRelayObj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // Set the initial CR bootstrap nodes based on the type of IPFS node.
                bootstrapRelays = [];

                if (thisNode.type === 'browser') {
                  bootstrapRelays = bootstrapCircuitRelays.browser;
                } else {
                  bootstrapRelays = bootstrapCircuitRelays.node;
                } // Loop through each bootstrap Relay.


                i = 0;

              case 4:
                if (!(i < bootstrapRelays.length)) {
                  _context.next = 15;
                  break;
                }

                thisRelay = bootstrapRelays[i]; // Attempt to connect to the Circuit Relay peer.

                _context.next = 8;
                return this.adapters.ipfs.connectToPeer(thisRelay.multiaddr);

              case 8:
                connectionStatus = _context.sent;
                now = new Date();
                newRelayObj = {
                  multiaddr: thisRelay.multiaddr,
                  connected: connectionStatus,
                  updatedAt: now,
                  ipfsId: thisRelay.ipfsId,
                  isBootstrap: true,
                  metrics: {
                    aboutLatency: []
                  }
                }; // Record relay information in thisNode entity.

                thisNode.relayData.push(newRelayObj);

              case 12:
                i++;
                _context.next = 4;
                break;

              case 15:
                return _context.abrupt("return", true);

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);
                console.error('Error in relay-use-case.js/initializeRelays()');
                throw _context.t0;

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 18]]);
      }));

      function initializeRelays(_x) {
        return _initializeRelays.apply(this, arguments);
      }

      return initializeRelays;
    }() // Download a list of Circuit Relays from a GitHub Gist, and try to connect
    // to all of the ones in the list.

  }, {
    key: "getCRGist",
    value: function () {
      var _getCRGist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(thisNode) {
        var _this = this;

        var gistCRs, gistRelays, _loop, i, _ret;

        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.adapters.gist.getCRList();

              case 3:
                gistCRs = _context3.sent;

                if (thisNode.type === 'browser') {
                  gistRelays = gistCRs.browser;
                } else {
                  gistRelays = gistCRs.node;
                }

                console.log("Relays from the gist: ".concat(JSON.stringify(gistRelays, null, 2)));
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                  var thisRelay, alreadyExists, connectionStatus, now, newRelayObj;
                  return _regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          thisRelay = gistRelays[i]; // If this relay is already in the list of circuit relays, then skip.

                          alreadyExists = thisNode.relayData.filter(function (x) {
                            return x.ipfsId === thisRelay.ipfsId;
                          });

                          if (!alreadyExists.length) {
                            _context2.next = 4;
                            break;
                          }

                          return _context2.abrupt("return", "continue");

                        case 4:
                          // Attempt to connect to the Circuit Relay peer.
                          console.log("getCRGist() Connecting to Circuit Relay ".concat(thisRelay.multiaddr));
                          _context2.next = 7;
                          return _this.adapters.ipfs.connectToPeer(thisRelay.multiaddr);

                        case 7:
                          connectionStatus = _context2.sent;
                          now = new Date();
                          newRelayObj = {
                            multiaddr: thisRelay.multiaddr,
                            connected: connectionStatus,
                            updatedAt: now,
                            ipfsId: thisRelay.ipfsId,
                            isBootstrap: false,
                            metrics: {
                              aboutLatency: []
                            }
                          }; // Record relay information in thisNode entity.

                          thisNode.relayData.push(newRelayObj);

                        case 11:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 8:
                if (!(i < gistRelays.length)) {
                  _context3.next = 16;
                  break;
                }

                return _context3.delegateYield(_loop(i), "t0", 10);

              case 10:
                _ret = _context3.t0;

                if (!(_ret === "continue")) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("continue", 13);

              case 13:
                i++;
                _context3.next = 8;
                break;

              case 16:
                _context3.next = 18;
                return this.removeDuplicates(thisNode);

              case 18:
                return _context3.abrupt("return", true);

              case 21:
                _context3.prev = 21;
                _context3.t1 = _context3["catch"](0);
                console.error('Error in relay-use-case.js/getCRGist()');
                throw _context3.t1;

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this, [[0, 21]]);
      }));

      function getCRGist(_x2) {
        return _getCRGist.apply(this, arguments);
      }

      return getCRGist;
    }() // Renew the connection to each circuit relay in the state.

  }, {
    key: "connectToCRs",
    value: function () {
      var _connectToCRs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(thisNode) {
        var _this2 = this;

        var knownRelays, _loop2, i;

        return _regeneratorRuntime.wrap(function _callee3$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                knownRelays = thisNode.relayData; // Sort the Relays by their latency. This way Relays with the lowest latency
                // (relative to thisNode) are used first.

                knownRelays = this.sortRelays(knownRelays); // console.log('knownRelays: ', knownRelays)

                _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2(i) {
                  var thisRelay, connectedPeers, connectedPeer, now;
                  return _regeneratorRuntime.wrap(function _loop2$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          thisRelay = knownRelays[i]; // console.log('thisRelay: ', thisRelay)
                          // Get connected peers

                          _context4.next = 3;
                          return _this2.adapters.ipfs.getPeers();

                        case 3:
                          connectedPeers = _context4.sent;
                          // console.log('connectedPeers: ', connectedPeers)
                          // Check if target circuit-relay is currently conected to the node.
                          connectedPeer = connectedPeers.filter(function (peerObj) {
                            return thisRelay.multiaddr.match(peerObj.peer);
                          }); // console.log('connectedPeer: ', connectedPeer)
                          // Update the connection state.

                          if (!connectedPeer.length) {
                            _context4.next = 10;
                            break;
                          }

                          // Already connected.
                          thisRelay.connected = true;
                          console.log("Already connected to Circuit Relay ".concat(thisRelay.multiaddr));
                          _context4.next = 16;
                          break;

                        case 10:
                          // If this node is not connected, try to connect again.
                          console.log("Connecting to Circuit Relay ".concat(thisRelay.multiaddr));
                          _context4.next = 13;
                          return _this2.adapters.ipfs.connectToPeer(thisRelay.multiaddr);

                        case 13:
                          thisRelay.connected = _context4.sent;
                          console.log("thisRelay.connected: ".concat(thisRelay.connected));

                          if (thisRelay.connected) {
                            _this2.adapters.log.statusLog(0, "Connected to Circuit Relay peer ".concat(thisRelay.ipfsId));

                            console.log("connectToCRs() Connected to Circuit Relay peer ".concat(thisRelay.ipfsId));
                          }

                        case 16:
                          // console.log('thisRelay.connected: ', thisRelay.connected)
                          // Update the timestamp.
                          now = new Date();
                          thisRelay.updatedAt = now; // Update the state tracked by This Node.

                          thisNode.relayData[i] = thisRelay;

                        case 19:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _loop2);
                });
                i = 0;

              case 5:
                if (!(i < knownRelays.length)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.delegateYield(_loop2(i), "t0", 7);

              case 7:
                i++;
                _context5.next = 5;
                break;

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t1 = _context5["catch"](0);
                console.log('Error in connectToCRs()');

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee3, this, [[0, 12]]);
      }));

      function connectToCRs(_x3) {
        return _connectToCRs.apply(this, arguments);
      }

      return connectToCRs;
    }() // Sort the relay data relative to the measured latency metrics.

  }, {
    key: "sortRelays",
    value: function sortRelays(relayData) {
      try {
        // Loop through each element and add a latency score.
        for (var i = 0; i < relayData.length; i++) {
          var thisRelay = relayData[i]; // Ensure an initial default value is assigned.

          thisRelay.latencyScore = 10000; // Assign bootstrap nodes the maximum latency.

          if (thisRelay.isBootstrap) {
            thisRelay.latencyScore = 10000;
          } else {
            // Average the latencies measured for this Relay.
            thisRelay.latencyScore = Math.floor(this._average(thisRelay.metrics.aboutLatency)); // Handle corner-case of empty arrays.

            if (isNaN(thisRelay.latencyScore)) thisRelay.latencyScore = 10000;
          } // console.log('thisRelay: ', thisRelay)

        } // Sort the array by the latency score.
        // https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/


        var sortedList = relayData.sort(function (a, b) {
          return a.latencyScore > b.latencyScore ? 1 : -1;
        }); // console.log('Relay sortedList: ', sortedList)

        return sortedList;
      } catch (err) {
        console.error('Error in sortRelays()');
        throw err;
      }
    } // Average together the elements of an array.

  }, {
    key: "_average",
    value: function _average(arr) {
      return arr.reduce(function (p, c) {
        return p + c;
      }, 0) / arr.length;
    } // If a subnet Peer has the isCircuitRelay flag set, try to connect to them
    // directly. If the connection succeeds, add them to the list of Circuit Relays.
    // Triggered when a new subnet peer is found that has their Relay flag set.

  }, {
    key: "addRelay",
    value: function () {
      var _addRelay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ipfsId, thisNode) {
        var now, alreadyInList, peerData, isCircuitRelay, circuitRelayInfo, ip4TcpMultiaddr, dnsMultiaddr, multiaddr, connectSuccess, i, thisAddr, peers, thisRelay, isIp4, isIp6, isDns, isBridged, newRelayObj;
        return _regeneratorRuntime.wrap(function _callee4$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                now = new Date(); // console.log(`debug: addRelay() called at ${now.toLocaleString()}`)
                // Check to see if peer is already in the list of Circuit Relays.

                alreadyInList = thisNode.relayData.filter(function (x) {
                  return x.ipfsId.includes(ipfsId);
                }); // Exit if this peer is already in the list of Relays.

                if (!alreadyInList.length) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", true);

              case 5:
                // this.adapters.log.statusLog(1, 'New Circuit Relay Peer Found!')
                // Get the peer data.
                peerData = thisNode.peerData.filter(function (x) {
                  return x.data.ipfsId === ipfsId;
                });
                peerData = peerData[0]; // console.log('peerData: ', peerData)
                // Exit if this peer is not a circuit relay.
                // CT Added 9/4/21.
                // Added because testing was showing that some non-relay peers where getting
                // pings with about metrics.

                isCircuitRelay = peerData.data.isCircuitRelay;

                if (isCircuitRelay) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt("return", false);

              case 10:
                // Return true?
                this.adapters.log.statusLog(1, "New Circuit Relay Peer Found: ".concat(peerData.from)); // Grab the optional connection information if the Circuit Relay provides
                // it. If they do, construct a connection string and add it to the
                // list of multiaddrs.

                circuitRelayInfo = peerData.data.circuitRelayInfo;

                if (circuitRelayInfo) {
                  if (circuitRelayInfo.ip4) {
                    ip4TcpMultiaddr = "/ip4/".concat(circuitRelayInfo.ip4, "/tcp/").concat(circuitRelayInfo.tcpPort, "/p2p/").concat(peerData.from);
                    peerData.data.ipfsMultiaddrs.push(ip4TcpMultiaddr);
                  }

                  if (circuitRelayInfo.crDomain) {
                    dnsMultiaddr = "/dns4/".concat(circuitRelayInfo.crDomain, "/tcp/443/wss/ipfs/").concat(peerData.from);
                    peerData.data.ipfsMultiaddrs.push(dnsMultiaddr);
                  } // Debugging
                  // console.log(
                  //   `peer multiaddrs: ${JSON.stringify(
                  //     peerData.data.ipfsMultiaddrs,
                  //     null,
                  //     2
                  //   )}`
                  // )

                }

                multiaddr = '';
                connectSuccess = false; // Try to connect to one of the multiaddrs.

                i = 0;

              case 16:
                if (!(i < peerData.data.ipfsMultiaddrs.length)) {
                  _context6.next = 44;
                  break;
                }

                thisAddr = peerData.data.ipfsMultiaddrs[i]; // Try to connect to the IPFS peer.

                _context6.next = 20;
                return this.adapters.ipfs.connectToPeer(thisAddr);

              case 20:
                connectSuccess = _context6.sent;

                if (!connectSuccess) {
                  _context6.next = 40;
                  break;
                }

                _context6.next = 24;
                return this.adapters.ipfs.getPeers();

              case 24:
                peers = _context6.sent;
                // console.log('addRelay() peers: ', peers)
                // Retrieve the multiaddr that worked for connecting.
                thisRelay = peers.filter(function (x) {
                  return x.peer === ipfsId;
                });
                multiaddr = thisRelay[0].addr.toString(); // console.log('multiaddr: ', multiaddr)
                // If multiaddr does not contain ip4, ip6, or dns, then reject it,
                // because the connection is happening through another Relay.
                // If the multiaddr has 'p2p-circuit' in it, then it's also happening
                // through a Relay and should be rejected.

                isIp4 = multiaddr.includes('ip4');
                isIp6 = multiaddr.includes('ip6');
                isDns = multiaddr.includes('dns');
                isBridged = multiaddr.includes('p2p-circuit');

                if (!(!isIp4 && !isIp6 && !isDns || isBridged)) {
                  _context6.next = 37;
                  break;
                }

                this.adapters.log.statusLog(1, "Rejecting Relay multiaddr ".concat(multiaddr)); // Disconnect from the peer, so that a direct connection can be
                // attempted.

                _context6.next = 35;
                return this.adapters.ipfs.disconnectFromPeer(ipfsId);

              case 35:
                connectSuccess = false;
                return _context6.abrupt("continue", 41);

              case 37:
                return _context6.abrupt("break", 44);

              case 40:
                this.adapters.log.statusLog(1, "Connecting to potential relay did not succeed with multiaddr ".concat(thisAddr));

              case 41:
                i++;
                _context6.next = 16;
                break;

              case 44:
                if (connectSuccess) {
                  _context6.next = 47;
                  break;
                }

                this.adapters.log.statusLog(1, ": Could not add potential Circuit Relay: ".concat(ipfsId));
                return _context6.abrupt("return", false);

              case 47:
                // Add tail end of multiaddr if it's omitted. (this happens in go-ipfs v0.11.0)
                if (!multiaddr.includes(ipfsId)) {
                  multiaddr = "".concat(multiaddr, "/p2p/").concat(ipfsId);
                } // On successful connection, add the Circuit Relay to the list.
                // const now = new Date()


                newRelayObj = {
                  multiaddr: multiaddr,
                  connected: true,
                  updatedAt: now,
                  ipfsId: ipfsId,
                  isBootstrap: false,
                  metrics: {
                    aboutLatency: []
                  }
                }; // console.log(`newRelayObj: ${JSON.stringify(newRelayObj, null, 2)}`)

                thisNode.relayData.push(newRelayObj);
                console.log("New Circuit Relay added: ".concat(multiaddr));
                return _context6.abrupt("return", true);

              case 54:
                _context6.prev = 54;
                _context6.t0 = _context6["catch"](0);
                console.error('Error in addRelay(): ', _context6.t0); // top-level function. Do not throw an error.

                return _context6.abrupt("return", false);

              case 58:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee4, this, [[0, 54]]);
      }));

      function addRelay(_x4, _x5) {
        return _addRelay.apply(this, arguments);
      }

      return addRelay;
    }() // Called when periodically checking the Relay connection. Maintains network
    // metrics about each Relay.
    // Called by the manageCircuitRelays() Timer Controller.

  }, {
    key: "measureRelays",
    value: function () {
      var _measureRelays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(thisNode) {
        var _this3 = this;

        var _loop3, i, _ret2;

        return _regeneratorRuntime.wrap(function _callee5$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _loop3 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop3(i) {
                  var thisRelay, peerData, startTime, testResult, endTime, diffTime;
                  return _regeneratorRuntime.wrap(function _loop3$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          thisRelay = thisNode.relayData[i]; // If the relay is from the bootstrap list, skip it.
                          // if (thisRelay.isBootstrap) continue
                          // Get the peer data.

                          peerData = thisNode.peerData.filter(function (x) {
                            // console.log(`x.data.ipfsId: ${x.data.ipfsId}`)
                            // console.log(`thisRelay.ipfsId: ${thisRelay.ipfsId}`)
                            return x.data.ipfsId === thisRelay.ipfsId;
                          });
                          peerData = peerData[0]; // console.log(`peerData: ${JSON.stringify(peerData, null, 2)}`)
                          // Skip if this Relay is not advertising as a relay.

                          if (!(!peerData || !peerData.data.isCircuitRelay)) {
                            _context7.next = 5;
                            break;
                          }

                          return _context7.abrupt("return", "continue");

                        case 5:
                          if (thisRelay.connected) {
                            _context7.next = 8;
                            break;
                          }

                          thisRelay.metrics.aboutLatency.push(10000);
                          return _context7.abrupt("return", "continue");

                        case 8:
                          // Poll the /about JSON endpoint, and track the time it takes to recieve
                          // a response.
                          startTime = new Date();
                          _context7.next = 11;
                          return _this3.adapters.pubsub.about.queryAbout(thisRelay.ipfsId, thisNode);

                        case 11:
                          testResult = _context7.sent;
                          // await this.adapters.bch.bchjs.Util.sleep(2000)
                          endTime = new Date();
                          diffTime = 10000;
                          if (testResult) diffTime = endTime.getTime() - startTime.getTime(); // console.log(`Time difference: ${diffTime} mS`)
                          // Prune the metrics array if it's too big.

                          if (thisRelay.metrics.aboutLatency.length > 9) {
                            thisRelay.metrics.aboutLatency.shift();
                          } // Save the new metric value.


                          thisRelay.metrics.aboutLatency.push(diffTime);

                        case 17:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _loop3);
                });
                i = 0;

              case 3:
                if (!(i < thisNode.relayData.length)) {
                  _context8.next = 11;
                  break;
                }

                return _context8.delegateYield(_loop3(i), "t0", 5);

              case 5:
                _ret2 = _context8.t0;

                if (!(_ret2 === "continue")) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt("continue", 8);

              case 8:
                i++;
                _context8.next = 3;
                break;

              case 11:
                _context8.next = 17;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t1 = _context8["catch"](0);
                console.error('Error in measureRelays(): ', _context8.t1);
                throw _context8.t1;

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee5, null, [[0, 13]]);
      }));

      function measureRelays(_x6) {
        return _measureRelays.apply(this, arguments);
      }

      return measureRelays;
    }() // Remove any duplicate entries of Circuit Relays.
    // This is middleware that edits the thisNode.relayData in place.

  }, {
    key: "removeDuplicates",
    value: function removeDuplicates(thisNode) {
      try {
        var startingRelays = thisNode.relayData; // console.log('thisNode.relayData: ', thisNode.relayData)
        // https://stackoverflow.com/questions/2218999/how-to-remove-all-duplicates-from-an-array-of-objects

        var endingRelays = startingRelays.filter(function (relay, index, self) {
          return index === self.findIndex(function (t) {
            return t.ipfsId === relay.ipfsId;
          });
        }); // console.log('endingRelays: ', endingRelays)

        thisNode.relayData = endingRelays;
        return true;
      } catch (err) {
        console.error('Error in removeDuplicates()');
        throw err;
      }
    }
  }]);

  return RelayUseCases;
}();

module.exports = RelayUseCases;